import axios from 'axios';
import { showLoadingAction, hideLoadingAction } from '../../forms/loading-screen/actions';
import { env } from '../../env';
import { Claim } from '../../claim';
import { openDialogAction } from '../../confirmation-dialog';
import { ReduxThunkAction } from '../../redux/redux-actions';

type UpdateBeneficiaryReturn = Promise<any>;

export type UpdateBeneficiaries = () => UpdateBeneficiaryReturn;
type UpdateBeneficiariesAction = () => ReduxThunkAction<UpdateBeneficiaryReturn>;
export const updateBeneficiariesAction: UpdateBeneficiariesAction = () => {
    return async (dispatch, getState) => {
        const claim = getState().claimSession.claim;
        const beneficiaryUri = `${env().CLAIMS_API}/api/Claim/${claim.claimId}/Beneficiaries`;

        await submitBeneficiaries(dispatch, beneficiaryUri);
    };
};

async function submitBeneficiaries(dispatch: any, beneficiaryUri: string) {
    dispatch(showLoadingAction());
    await axios
        .post<Claim>(beneficiaryUri)
        .then(response => {
            if (response.data.claimId !== undefined) {
                dispatch(
                    openDialogAction({
                        content: {
                            title: 'Beneficiaries successful',
                            body: 'The update to compass was successfully sent',
                        },
                    })
                );
            } else {
                dispatch(
                    openDialogAction({
                        content: {
                            title: 'Beneficiaries Failed',
                            body: 'The request to Compass failed. Please contact support team',
                        },
                    })
                );
            }
        })
        .catch(error => {
            let errorMessage = '';
            if (error.response) {
                let message = `The request to Compass failed. Please contact support team`;
                if (error.response.data && error.response.data.error) {
                    message = `The request to Compass failed. Please contact support team`;
                }
                errorMessage = message;
            } else {
                errorMessage = error.message;
            }
            showErrorMessage(errorMessage);
        })
        .then(() => dispatch(hideLoadingAction()));

    function showErrorMessage(errorMessage: any) {
        dispatch(
            openDialogAction({
                content: {
                    title: 'Error submitting Beneficiaries',
                    body: errorMessage,
                    error: true,
                },
            })
        );
    }
}
